import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import UserContext from "../../context/user";

const useOsteopathDeleteMutation = () => {
  const { callApi, userProfile } = useContext(UserContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ requestId }) =>
      callApi(`/osteopath/request/${requestId}`, {
        method: "DELETE",
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
      },
    }
  );
};

export default useOsteopathDeleteMutation;
